// opervex-frontend/src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { LoadingProvider } from "./contexts/LoadingContext";

import { AuthProvider } from "./contexts/AuthContext";

import MainLayout from "./layout/MainLayout";
import routes from "./routes";
import PrivateRouteWrapper from "./routes/privateRouteWrapper";

import RootRedirect from "./routes/RootRedirect";
import StartTenent from "./pages/StartTenent";

/**
 * =====================================
 * Helper para rotas privadas com tenant
 * =====================================
 */
const AddPrivateRoute = (path, page, requiredRoles, admin) => (
  <Route
    key={path}
    path={`/:tenantId/${path}`}
    element={
      <MainLayout>
        <PrivateRouteWrapper requiredRoles={requiredRoles} admin={admin}>
          {page}
        </PrivateRouteWrapper>
      </MainLayout>
    }
  />
);

function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <Router>
          <Routes>
            {/* ============================= */}
            {/* ROTA RAIZ INTELIGENTE */}
            {/* ============================= */}
            <Route path="/" element={<RootRedirect />} />

            {/* ============================= */}
            {/* START TENANT (PÚBLICA) */}
            {/* ============================= */}
            <Route path="/StartTenent" element={<StartTenent />} />

            {/* ============================= */}
            {/* ROTAS DINÂMICAS DO SISTEMA */}
            {/* ============================= */}
            {routes.map((route) => {
              // 🔒 ROTAS PRIVADAS
              if (route.private) {
                return AddPrivateRoute(route.path, route.component, route.role, route?.admin);
              }

              // 🌐 ROTAS SEM TENANT (MAS PODEM TER)
              if (route.addWithoutTenantId) {
                return (
                  <React.Fragment key={route.path}>
                    <Route path={route.path} element={route.component} />
                    <Route path={`/:tenantId/${route.path}`} element={route.component} />
                  </React.Fragment>
                );
              }

              // 🔹 ROTAS PADRÃO COM TENANT
              return <Route key={route.path} path={`/:tenantId/${route.path}`} element={route.component} />;
            })}

            {/* ============================= */}
            {/* CATCH-ALL INTELIGENTE */}
            {/* ============================= */}
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </Router>
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App;
